import React from 'react'

import WistiaVideo from './WistiaVideo'

import './styles.scss'
const bc = 'activity-video'

const ActivityVideo = () => (
  <div className={bc}>
    <div className={`${bc}__video-container`}>
      <WistiaVideo />
    </div>
  </div>
)

export default ActivityVideo
